import { useLazyQuery } from "@apollo/client/react";import { useEffect, useState } from "react";

import { AdaptPreciosControl, GET_PRECIOS_CONTROL } from "../../../../data/graphQL/queries/PrecioControl/getPreciosControl";
import toast from "react-hot-toast";

export const useGetRows = (filter, setIsRefetchRequired) => {
  const [rows, setRows] = useState([]);

  const [getPrecios, { data: dataPrecios, loadingRows, error: errorPrecios }] = useLazyQuery(GET_PRECIOS_CONTROL, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!dataPrecios) return;
    setRows(AdaptPreciosControl(dataPrecios));
    setIsRefetchRequired(false);
  }, [dataPrecios]);  

  useEffect(() => {
		if (!errorPrecios) return;
    toast.error('No se pudo cargar la tabla de precios, intentelo nuevamente más tarde.');
  }, [errorPrecios]);    

  const handleSearch = () => {
    getPrecios({
      variables: {
        filter:
        {
          ...filter,
          idDelegacion: filter.idDelegacion === -1 ? 0 : filter.idDelegacion
        }
      }
    });
  };
  console.log(filter);
  useEffect(() => {
    handleSearch();
  }, [filter]);

  return {
    rows,
    setRows,
    loading: loadingRows,
    totalCount: rows.length || 0,
    handleSearch
  };

};